/**
 * List of all possible email template types.
 */
export enum EmailTemplateType {
  shiftRequestReceived = 'shiftRequestReceived',
  shiftRequestApproved = 'shiftRequestApproved',
  shiftRequestDenied = 'shiftRequestDenied',
}
